import { render, staticRenderFns } from "./supplierSLAs.vue?vue&type=template&id=3b213bae&"
import script from "./supplierSLAs.vue?vue&type=script&lang=js&"
export * from "./supplierSLAs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports